export default {
  main: {
    site_id: 18756499,
    title: "MoolaBet",
    logoSize: "big",
    hotjarId: 4937898,
    staffPassword: "68524238",
    websitePasswordHash: "83fc70c374d76688295ef1f17593bd65c67088be36c7bfdb99fe1b1d9d3b8cda",
    homeMediaSlides: [
      {
        type: "sport",
        path: "betting/prematch",
      },
    ],
    availableLanguages: {
      "@replace": true,
      por: {
        short: "PT",
        name: "POR",
        region: "UnitedKingdom",
        order: 2,
      },
      eng: {
        short: "EN",
        name: "ENG",
        region: "UnitedKingdom",
        order: 1,
      },
      chi: {
        short: "CH",
        name: "繁体中文",
        order: 3,
      },
      ger: {
        short: "DE",
        name: "DEU",
        order: 4,
      },
    },
  },
  routes: [
    {
      name: 'Betting',
      url: 'betting/prematch/all',
      type: 'sportsBook',
      enabled: true,
      nestedItems: [
        {
          url: 'betting/live/all',
          type: 'live',
          name: 'Live',
          enabled: true,
          icon: 'circle',
        },
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'Sports',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
        {
          url: 'betting/results',
          name: 'Results',
          type: 'results',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      name: 'Casino',
      url: 'casino',
      type: 'casino',
      enabled: true,
    },
    {
      url: "tickets",
      name: "Tickets",
      enabled: true,
    },
  ],
  lastTicketButtons: [
    {
      name: "Bet tickets",
      type: "betTicket",
      hideOnRestrictMode: false,
    },
    {
      name: "Cash-out",
      type: "cashoutTicket",
      hideOnRestrictMode: false,
    },
  ],
  "defaultTerminalParams": { pid: 18756499, tid: 31964, token: "ZmMlEQ==", currency: 'NAD' },

  sportsbook: {
    "enablePredefinedMultiples": false,
    "enableBoostedOdds": false,
    "sportList": {
    }
  }
};
